import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IState } from '@models/index';

export const configSelector = createFeatureSelector<IState>('config');
export const getconfigsSelector = createSelector(configSelector, (state: IState) => state); 
export const getconfigSelector = createSelector(configSelector, (state: IState) => state.selectedItem); 

